module.exports = __webpack_public_path__ + "static/img/seoul-120-pt.5917086.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/visual-marketing-detail/seoul-120-pt.jpg
// module id = dbwg
// module chunks = 0